const DEV_TOOLS_KEY = 'appcues:devtools:features';

export type DevToolsClient = {
  has(key: string): boolean;
  get(key: string): boolean;
  getAll(): Record<string, boolean>;
  set(key: string, value: boolean): void;
  reset(key: string): void;
  resetAll(): void;
};

export default function createDevToolsClient(
  storageKey = DEV_TOOLS_KEY
): DevToolsClient {
  const stored = localStorage.getItem(storageKey);
  const overrides = stored ? JSON.parse(stored) : {};

  return {
    has(key: string) {
      return Object.hasOwn(overrides, key);
    },
    get(key: string) {
      return overrides[key];
    },
    getAll() {
      return overrides;
    },
    set(key: string, value: boolean) {
      overrides[key] = value;
      localStorage.setItem(storageKey, JSON.stringify(overrides));
      window.location.reload();
    },
    reset(key: string) {
      delete overrides[key];
      localStorage.setItem(storageKey, JSON.stringify(overrides));
      window.location.reload();
    },
    resetAll() {
      localStorage.removeItem(storageKey);
      window.location.reload();
    },
  };
}
